module.exports = __webpack_public_path__ + "media/assets/images/payments/ec_maestro-10ccae7fc95e63259cae08e6cb377001.png";